import { all, fork, put, takeLatest } from "redux-saga/effects";
import actions from "../actions";
import CONSTANTS from "../CONSTANTS";
import { formatByIdSaga } from "src/store/helpers/formatByIdSaga";
import { toast } from "react-toastify";

export const SERVICE_CENTER_URL =
  "/services/rcp/profile/appointment/servicepoint/";

export function* getPlannedVisitsServiceCenter() {
  yield takeLatest(
    CONSTANTS.GET_MAIN_PLANNED_VISITS_SERVICE_CENTER,
    function* (action) {
      try {
        yield put(actions.setPlannedVisitsServiceCenter(undefined));

        const url =
          SERVICE_CENTER_URL +
          "PlannedVisitsServiceCenter?policyNo=" +
          action.payload;
        const res = yield window.mainAxios.get(url).then((r) => r.data);
        // console.log(res)
        // eslint-disable-next-line no-throw-literal
        if (!res.success)
          throw {
            errorCode: res.errorCode,
            errorMessage: res.errorMessage,
          };

        const data = res.data;

        yield put(actions.setPlannedVisitsServiceCenter(data));
      } catch (e) {
        yield put(actions.setPlannedVisitsServiceCenter([]));
        console.error(e);
      }
    }
  );
}
export function* getDeleteReservation() {
  yield takeLatest(CONSTANTS.GET_MAIN_DELETE_RESERVATION, function* (action) {
    try {
      yield put(actions.setDeleteReservation(null));

      const url =
        SERVICE_CENTER_URL + "DeleteReservation?oid=" + action.payload;
      const res = yield window.mainAxios.delete(url).then((x) => x.data);

      // eslint-disable-next-line no-throw-literal
      if (!res.success)
        throw {
          errorCode: res.errorCode,
          errorMessage: res.errorMessage,
        };
      const message = yield formatByIdSaga("notifications.consultationDeleted");
      toast.success(message);

      yield put(actions.setServiceCenterUpdateCounter());
      yield put(actions.setDeleteReservation(true));
    } catch (e) {
      const message = yield formatByIdSaga(
        "notifications.consultationCouldntBeDeleted"
      );
      toast.error(message);

      yield put(actions.setDeleteReservation(false));
    }
  });
}

export default function* serviceCenterSaga() {
  yield all([fork(getPlannedVisitsServiceCenter), fork(getDeleteReservation)]);
}
